import React from "react";

const BadGuyIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.99991 11.6132L3.71991 12.3332L2.18658 13.8532C1.99991 14.0465 1.66658 14.0465 1.47991 13.8532C1.29325 13.6598 1.28658 13.3332 1.47991 13.1465L2.99991 11.6132ZM12.1932 3.61317V2.6665L7.99991 6.85984L3.80658 2.6665V3.61317L7.52658 7.33317L4.99991 9.87317C4.21325 9.31317 3.11991 9.37984 2.41991 10.0798L5.25325 12.9132C5.95325 12.2132 6.01991 11.1198 5.46658 10.3332L12.1932 3.61317ZM14.5199 13.1465L12.9999 11.6132L12.2799 12.3332L13.8132 13.8532C13.9999 14.0465 14.3332 14.0465 14.5199 13.8532C14.7066 13.6598 14.7132 13.3332 14.5199 13.1465ZM10.9999 9.87317L8.94658 7.8065L8.47325 8.27984L10.5399 10.3332C9.97991 11.1198 10.0466 12.2132 10.7466 12.9132L13.5799 10.0798C12.8799 9.37984 11.7866 9.31317 10.9999 9.87317Z" fill="white"/>
    </svg>
  );
};

export default BadGuyIcon;
